export default [
  {
    id: 0,
    type: 'very_easy',
    title: 'Very Easy',
    baseAmounts: [16, 25, 36, 49],
  },
  {
    id: 1,
    type: 'easy',
    title: 'Easy',
    baseAmounts: [64, 81, 100, 121],
  },
  {
    id: 2,
    type: 'normal',
    title: 'Normal',
    baseAmounts: [144, 169, 196],
  },
  {
    id: 3,
    type: 'hard',
    title: 'Hard',
    baseAmounts: [225, 256, 281, 324],
  },
  {
    id: 4,
    type: 'difficult',
    title: 'Difficult',
    baseAmounts: [361, 400, 441, 484, 576, 676, 841, 1089],
  },
];



// WEBPACK FOOTER //
// ./src/views/games/puzzles/presets.js